export default __webpack_public_path__ + "eccaa700613c0262ff6209f3a515cbcf.wav";